var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15235 15.8789C7.60624 15.8789 8.78907 14.6961 8.78907 13.2422V9.66797C8.78907 8.21408 7.60624 7.03125 6.15235 7.03125C6.00253 7.03125 5.85575 7.04449 5.71272 7.06863C6.79038 3.97998 9.73214 1.75781 13.1836 1.75781C16.6351 1.75781 19.5768 3.97998 20.6545 7.06863C20.5115 7.04449 20.3647 7.03125 20.2149 7.03125C18.761 7.03125 17.5781 8.21408 17.5781 9.66797V13.2422C17.5781 14.6961 18.761 15.8789 20.2149 15.8789C21.6687 15.8789 22.8516 14.6961 22.8516 13.2422V9.66797C22.8516 4.33705 18.5145 0 13.1836 0C7.85268 0 3.51563 4.33705 3.51563 9.66797V13.2422C3.51563 14.6961 4.69847 15.8789 6.15235 15.8789ZM26.3554 28.9777L25.087 21.3088C24.7324 19.1811 22.9094 17.6367 20.7523 17.6367H5.61493C3.4578 17.6367 1.63477 19.1811 1.28005 21.3098L0.0117859 28.9777C-0.030343 29.2324 0.0416688 29.4927 0.208602 29.6896C0.375653 29.8865 0.620751 30 0.878915 30H5.27345L7.67579 29.1211H18.75L21.0938 30H25.4883C25.7465 30 25.9916 29.8865 26.1585 29.6896C26.3255 29.4928 26.3975 29.2324 26.3554 28.9777Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1836 17.6367C16.576 17.6367 19.3359 14.8505 19.3359 11.4258C19.3359 8.03338 16.576 5.27344 13.1836 5.27344C9.79119 5.27344 7.03125 8.03338 7.03125 11.4258C7.03125 14.8505 9.79119 17.6367 13.1836 17.6367ZM20.2148 21.1523H6.15234C5.66695 21.1523 5.27344 21.5459 5.27344 22.0312V30H21.0938V22.0312C21.0938 21.5459 20.7002 21.1523 20.2148 21.1523ZM13.1836 26.4258C12.6982 26.4258 12.3047 26.0323 12.3047 25.5469C12.3047 25.0615 12.6982 24.668 13.1836 24.668C13.669 24.668 14.0625 25.0615 14.0625 25.5469C14.0625 26.0323 13.669 26.4258 13.1836 26.4258Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 13.1836,
    y1: 30,
    x2: 13.1836,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AA6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 13.1836,
    y1: 30,
    x2: 13.1836,
    y2: 5.27344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.1b10f5770c1bad92546982f5b937cf55.svg";
export { ForwardRef as ReactComponent };